import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NotificationLayout } from '../../../shared/layout/notification-layout/notification-layout';

@Component({
  selector: 'app-user-retry',
  imports: [RouterLink, NotificationLayout],
  templateUrl: './user-retry.html',
  styleUrl: './user-retry.scss',
})
export class UserRetry implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}
  attemps: number = 0;
  ngOnInit() {
    this.attemps = +this.route.snapshot.paramMap.get('attemps')!;
    if (3 - this.attemps === 0) {
      this.router.navigate(['manual-activation']);
    }
  }
}
